import randomstring from 'randomstring';

export default class CustomVar {
  constructor(type) {
    this.event = type;
    this.key = '';
    this.value = '';
    this.symbol = randomstring.generate();
  }
};

export class ChartDataProp {
  constructor(name, type = '', linkFormat = '', linkProps = []) {
    this.name = name;
    this.type = type;
    this.linkFormat = linkFormat;
    this.linkProps = linkProps;
  }
};

export class RoleInfo {
  constructor(role, permissions, parentUser) {
    this.role = role || null;
    this.permissions = permissions || {};
    this.isRoot = !parentUser;
  }
};

export class ValueText {
  constructor(value, text) {
    this.value = value;
    this.text = text;
  }
};

export class PersistentFilters {
  constructor(userData) {
    this.filters = userData.persistent_filters;
    this.updateUrl = userData._links.update_persistent_filters.href;
  }
};